import React from 'react'

export default function Balances() {
  return (
    <div>Balances</div>
  )
}
